import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faAngleLeft, faAngleRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { deleteLink, getLinks } from '~/services/linkService';
import styles from './LinkList.module.scss';
import Title from '~/components/Title';
import { Link } from 'react-router-dom';
import routes from '~/config/routes';
import PushNotification from '~/components/PushNotification';

const LinkList = () => {
    const [links, setLinks] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [notification, setNotification] = useState({ message: '', type: '' });

    useEffect(() => {
        fetchLinks();
    }, [currentPage, itemsPerPage]);

    const fetchLinks = async () => {
        try {
            const data = await getLinks();
            if (data) {
                setLinks(data);
            } else {
                setNotification({ message: 'Có lỗi khi tải liên kết!', type: 'error' });
            }
        } catch (error) {
            console.error('Error fetching links:', error);
            setNotification({ message: 'Có lỗi khi tải liên kết.', type: 'error' });
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Bạn có chắc chắn muốn xóa hình liên kết này?')) {
            try {
                await deleteLink(id);
                setLinks(links.filter((link) => link._id !== id));
                setNotification({ message: 'Hình liên kết đã được xóa thành công!', type: 'success' });
            } catch (error) {
                console.error('Error deleting link:', error);
                setNotification({ message: 'Đã xảy ra lỗi khi xóa hình liên kết!', type: 'error' });
            }
        }
    };

    const filteredLinks = links.filter(
        (link) =>
            link.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            link.url.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    const totalPages = Math.ceil(filteredLinks.length / itemsPerPage);
    const indexOfLastLink = currentPage * itemsPerPage;
    const indexOfFirstLink = indexOfLastLink - itemsPerPage;
    const currentLinks = filteredLinks.slice(indexOfFirstLink, indexOfLastLink);

    return (
        <div className={styles.linkContainer}>
            <Title className={styles.pageTitle} text="Danh sách liên kết" />
            {notification.message && <PushNotification message={notification.message} type={notification.type} />}
            <div className={styles.actionsContainer}>
                <input
                    type="text"
                    placeholder="Tìm kiếm liên kết..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className={styles.searchInput}
                />
                <Link to={routes.addLink} className={styles.addButton}>
                    <FontAwesomeIcon icon={faPlus} /> Thêm mới liên kết
                </Link>
            </div>

            <div className={styles.linkList}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>Tên liên kết</th>
                            <th>Đường dẫn liên kết</th>
                            <th>Ngày tạo</th>
                            <th>Ngày cập nhật</th>
                            <th>Người tạo</th>
                            <th>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentLinks.length > 0 ? (
                            currentLinks.map((link) => (
                                <tr key={link._id}>
                                    <td>{link.name}</td>
                                    <td>
                                        <a href={link.url} target="_blank" rel="noopener noreferrer">
                                            {link.url}
                                        </a>
                                    </td>
                                    <td>{new Date(link.createdAt).toLocaleDateString()}</td>
                                    <td>{new Date(link.updatedAt).toLocaleDateString()}</td>
                                    <td>{link.createdBy}</td>
                                    <td>
                                        <button onClick={() => handleDelete(link._id)} className={styles.deleteButton}>
                                            <FontAwesomeIcon icon={faTrash} /> Xóa
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">Không có dữ liệu</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className={styles.itemsPerPage}>
                <label htmlFor="itemsPerPage">Hiển thị: </label>
                <select
                    id="itemsPerPage"
                    value={itemsPerPage}
                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                </select>
            </div>

            <div className={styles.pagination}>
                <span>
                    Hiển thị {indexOfFirstLink + 1} đến {Math.min(indexOfLastLink, filteredLinks.length)} của{' '}
                    {filteredLinks.length}
                </span>
                <div className={styles.paginationControls}>
                    <button
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </button>
                    <button
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                    >
                        <FontAwesomeIcon icon={faAngleRight} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LinkList;
